import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import useEventListener from '@use-it/event-listener';
import { Fragment, useCallback } from 'react';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { useScrollLocking } from '../../hooks/useScrollLocking';
import { ArrowLeftThickIcon } from '../../icons/arrowLeftThickIcon';
import { resetActiveConversation, thunkMarkDirectMessagesAsRead } from '../../redux/actions/directMessagesActions';
import { thunkShowPlayerInfo } from '../../redux/actions/playerInfoActions';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { PRIVATE_MESSAGES_PANEL_MESSAGES_BACKGROUND_COLOR } from '../../styles/colors';
import { PanelHeader } from '../panelHeader';
import { PANEL_CONTAINER_QUERY_CONTAINER_CLASS_NAME } from '../panelStyles';
import { DirectMessageDisplay } from './directMessageDisplay';
import { DirectMessageGroupHeadingContainer } from './directMessageGroupHeadingContainer';
import { DirectMessageInput } from './directMessageInput';
const MESSAGES_CONTAINER_CSS = css `
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: ${PRIVATE_MESSAGES_PANEL_MESSAGES_BACKGROUND_COLOR} !important;
  padding: 5px 5px 10px;
  border-radius: 0;
`;
export const ActiveConversationDisplay = ({ conversation }) => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const myPlayerId = useAppSelector((state) => state.selfData.id);
    const { messages } = conversation;
    const [setScrollLockingElementRef, onScroll] = useScrollLocking(messages);
    const onClickBack = useCallback(() => {
        dispatch(resetActiveConversation());
    }, [dispatch]);
    const onClickInfo = useCallback(() => {
        dispatch(thunkShowPlayerInfo(conversation.playerIdName, socketSend));
    }, [conversation.playerIdName, dispatch, socketSend]);
    const maybeMarkAsRead = useCallback(() => {
        dispatch(thunkMarkDirectMessagesAsRead(conversation, socketSend));
    }, [conversation, dispatch, socketSend]);
    useEventListener('keydown', maybeMarkAsRead);
    useEventListener('mousedown', maybeMarkAsRead);
    return (_jsxs(_Fragment, { children: [_jsx(PanelHeader, { title: conversation.playerIdName.name, headerLeft: _jsx(IconButton, { size: 'small', onClick: onClickBack, color: 'primary', title: 'Back to Conversations List', children: _jsx(ArrowLeftThickIcon, {}) }), headerRight: _jsx(IconButton, { size: 'small', onClick: onClickInfo, color: 'primary', title: 'Show Player Info', children: _jsx(ContactPageOutlinedIcon, {}) }), withPadding: true }), _jsx(Paper, { component: 'section', ref: setScrollLockingElementRef, onScroll: onScroll, "aria-label": `messages with ${conversation.playerIdName.name}`, css: MESSAGES_CONTAINER_CSS, className: PANEL_CONTAINER_QUERY_CONTAINER_CLASS_NAME, children: messages.map((message, i) => {
                    return (_jsxs(Fragment, { children: [_jsx(DirectMessageGroupHeadingContainer, { messages: messages, messageIndex: i, myPlayerId: myPlayerId, conversationPlayer: conversation.playerIdName }), _jsx(DirectMessageDisplay, { message: message, myPlayerId: myPlayerId, conversationPlayer: conversation.playerIdName })] }, i));
                }) }), _jsx(DirectMessageInput, { conversation: conversation })] }));
};
